import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17c13a64"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "write-signature-container" };
const _hoisted_2 = { class: "write-signature" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { id: "svg-signature" }, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedInput = _resolveComponent("FriedInput");
    const _component_CharacterCounter = _resolveComponent("CharacterCounter");
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FriedInput, {
            modelValue: _ctx.inputText,
            "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event) => ((_ctx.inputText) = $event)),
                _ctx.handleChange
            ],
            class: "name",
            "data-external": "write-signature-modal-text-input",
            label: _ctx.t('write-your-name'),
            maxlength: _ctx.maxLength
        }, null, 8, ["modelValue", "label", "maxlength", "onUpdate:modelValue"]),
        _createVNode(_component_CharacterCounter, {
            class: "character-counter",
            text: _ctx.inputText,
            "max-length": _ctx.maxLength
        }, null, 8, ["text", "max-length"]),
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (!_ctx.showWriteSignature)
                ? (_openBlock(), _createBlock(_component_FriedSpinner, {
                    key: 0,
                    class: "signature-loader"
                }))
                : _createCommentVNode("", true)
        ])
    ]));
}
